// Shared attachment presentation helpers, used by both the composer (ChatInput)
// and the message history (MessageBlock) so uploaded files look identical in
// both places — one source of truth for the type badge and size formatting.

export const attachmentKindFor = (mime: string, name: string): { className: string; label: string } => {
	const m = (mime || '').toLowerCase();
	if (m === 'application/pdf' || /\.pdf$/i.test(name)) return { className: 'pdf', label: 'PDF' };
	if (
		m === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
		m === 'application/vnd.ms-excel' ||
		/\.(xlsx|xls)$/i.test(name)
	) {
		return { className: 'xlsx', label: 'XLSX' };
	}
	if (m === 'text/csv' || /\.csv$/i.test(name)) return { className: 'xlsx', label: 'CSV' };
	if (
		m === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
		m === 'application/vnd.ms-powerpoint' ||
		/\.pptx?$/i.test(name)
	) {
		return { className: 'pptx', label: 'PPTX' };
	}
	if (m.startsWith('image/')) return { className: 'image', label: 'IMG' };
	if (m === 'application/json' || /\.json$/i.test(name)) return { className: 'text', label: 'JSON' };
	if (/\.sql$/i.test(name)) return { className: 'text', label: 'SQL' };
	if (m.startsWith('text/')) return { className: 'text', label: 'TXT' };
	return { className: 'text', label: 'FILE' };
};

export const formatBytes = (n?: number): string => {
	if (!n || n <= 0) return '';
	if (n < 1024) return `${n} B`;
	if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
	return `${(n / 1024 / 1024).toFixed(1)} MB`;
};
